import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const forwardToChangeMaintenanceOrderValue = createAction('CHANGE_MAINTENANCE_ORDER_VALUE');
export const forwardToChangeMaintenanceOrderDetailValue = createAction('CHANGE_MAINTENANCE_ORDER_DETAIL_VALUE');
export const forwardToChangeMaintenanceOrderActivePage = createAction('CHANGE_MAINTENANCE_ACTIVE_PAGE');
export const forwardToOpenAddMaintenanceOrderModal = createAction('OPEN_ADD_MAINTENANCE_ORDER_MODAL');
export const forwardToOpenEditMaintenanceOrderModal = createAction('OPEN_EDIT_MAINTENANCE_ORDER_MODAL');
export const forwardToOpenEditMaintenanceOrderDetailModal = createAction('OPEN_EDIT_Maintenance_ORDER_DETAIL_MODAL');
export const forwardToOpenViewMaintenanceOrderModal = createAction('OPEN_VIEW_MAINTENANCE_ORDER_MODAL');
export const forwardToCloseMaintenanceOrderModal = createAction('CLOSE_MAINTENANCE_ORDER_MODAL');


export const forwardToSelectDetailCategory = (index, category) => (
  (dispatch) => {
    dispatch({
      type: 'SET_DETAIL_CAT',
      payload: { index: index, category: category }
    });
  }
);

export const forwardToSelectDetailCheckSet = (index, category) => (
  (dispatch) => {
    dispatch({
      type: 'SET_DETAIL_CHECK_SET',
      payload: { index: index, category: category }
    });
  }
);

export const forwardToCreateNewMOrdeDetail = (request) => (

  (dispatch) => {
    let url = '/maintenance/orders/details';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'SET_M_ORDER_DETAILS',
        payload: json
      });
    });
    dispatch({
      type: 'RESET_DETAIL_CHECK_SET',
      payload: null
    });
  }
);

export const forwardToFindMOrderDetails = (orderId) => (
  (dispatch) => {
    let request = { orderId: orderId };
    let url = '/maintenance/orders/i' + orderId + '/details';
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'SET_M_ORDER_DETAILS',
        payload: json
      });
    });
  }
);

export const forwardToFindMaintenanceOrderDetailList = (payload) => (
  (dispatch) => {
    let url = '/maintenance/orders/i' + payload.orderId + '/orderDetails';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_ORDER_DETAIL_LIST',
        payload: json
      });
    });
  }
);


export const forwardToDeleteMaintenanceOrderDetail = (detailId, orderId) => (
  (dispatch) => {
    let request = {
      orderId: orderId,
      detailId: detailId,
    };
    let url = '/maintenance/orders/i' + orderId + '/orderDetails/i' + detailId;
    authFetch('POST', url, JSON.stringify(request), (json) => {
      dispatch({
        type: 'SET_M_ORDER_DETAILS',
        payload: json
      });
    });
  }
);


export const forwardToFindAllMaintenanceOrderIds = () => (
  (dispatch) => {
    let url = '/maintenance/orders/orderIds';
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_ALL_MAINTENANCE_ORDERIDS',
        payload: json
      });
    });
  }
);

export const forwardToFindMaintenanceOrderList = (pagingData, serachData) => (
  (dispatch) => {

    let searchDataUrl = '';
    if (serachData != null) {
      searchDataUrl = '&searchKeys=';
      for (let i = 0; i < serachData.searchKeys.length; i++) {
        searchDataUrl += serachData.searchKeys[i] + ',';
      }
      searchDataUrl += '&searchWord=' + serachData.searchWord;
    }

    let url = '/maintenance/orders?activePage=' + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage + searchDataUrl;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MANTENANCE_ORDER_LIST',
        payload: json
      });
    });
  }
);

export const forwardToAddMaintenanceOrder = (order, pagingData) => (
  (dispatch) => {
    let url = '/maintenance/orders';
    authFetch('POST', url, JSON.stringify(order), (json) => {
      dispatch({
        type: 'ADD_MAINTENANCE_ORDER',
        payload: json
      });
      dispatch(forwardToFindAllMaintenanceOrderIds());
      dispatch(forwardToFindMaintenanceOrderList(pagingData));
    });
  }
);

export const forwardToEditMaintenanceOrder = (order, pagingData) => (
  (dispatch) => {
    let url = '/maintenance/orders/' + order.get('orderId');
    authFetch('PUT', url, JSON.stringify(order), (json) => {
      dispatch({
        type: 'EDIT_MAINTENANCE_ORDER',
        payload: json
      });
      dispatch(forwardToFindMaintenanceOrderList(pagingData));
    });
  }
);

export const forwardToFindMaintenanceOrder = (pk) => (
  (dispatch) => {
    let url = '/maintenance/orders/' + pk.order_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_ORDER',
        payload: json
      });
    });
  }
);

/* TODO chichun : KK - 'remove ADD_MAINTENANCE_ORDER_DETAIL' */
// export const forwardToAddMaintenanceOrderDetail = (orderDetail) => (
//   (dispatch) => {
//     let url = '/maintenance/orders/' + orderDetail.orderId + '/orderDetails';
//     authFetch('POST', url, JSON.stringify(orderDetail), (json) => {
//       dispatch({
//         type: 'ADD_MAINTENANCE_ORDER_DETAIL',
//         payload: json
//       });
//       dispatch(forwardToFindMaintenanceOrderDetailList({orderId: orderDetail.get('orderId')}));
//     });
//   }
// );


export const forwardToDeleteMaintenanceOrder = (deleteKey, pagingData) => (
  (dispatch) => {
    let url = '/maintenance/orders';
    authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
      dispatch({
        type: 'DELETE_MAINTANENCE_ORDER',
        payload: json
      });
      dispatch(forwardToFindAllMaintenanceOrderIds());
      dispatch(forwardToFindMaintenanceOrderList(pagingData));
    });
  }
);

export const forwardToFindMaintenanceOrderDetail = (pk) => (
  (dispatch) => {
    let url = '/maintenance/orders/' + pk.order_id + '/orderDetails/' + pk.order_detail_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_MAINTENANCE_ORDER_DETAIL',
        payload: json
      });
    });
  }
);



// export const changeShowSpecIdHasLabel = (payload) => (
//   (dispatch) => {
//     let url = '/firefighter/common/gearHasLabel/' + payload.gear_name;
//     authFetch('GET', url, null, (json) => {
//       dispatch({
//         type: 'CHANGE_SHOW_SPECIDHASLABEL',
//         payload: json
//       });
//     });
//   }
// );


// WEBPACK FOOTER //
// ./src/actions/maintenanceOrderActions.js